import { TBroadcastTypePickerOptions } from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/broadcast-type-picker.types';
import { EBroadcastTypes, SessionTypesEnum } from '@/types/session.types';

const getSessionBroadcastTypeFromSelectedBroadcastType = (
  type: TBroadcastTypePickerOptions
): EBroadcastTypes | null => {
  let newBroadcastType: EBroadcastTypes | null;

  // on-demand and breakout rooms do not have a broadcast_type
  if (type === SessionTypesEnum.onDemand) {
    newBroadcastType = null;
  } else if (type === SessionTypesEnum.breakoutRooms) {
    newBroadcastType = null;
  } else {
    newBroadcastType = type;
  }

  return newBroadcastType;
};

export default getSessionBroadcastTypeFromSelectedBroadcastType;
